import React from 'react'

import { FacebookIcon, LinkedInIcon, TwitterIcon } from '@application/Interfaces/Icons'
import { SocialBannerType } from '@src/Application/Types/ComponentTypes'
import { Nullable } from '@src/Application/Types/Opt'

import {
    Button,
    Link,
    SocialBannerDescription,
    SocialBannerTitle,
    SocialBannerWrapper,
    SocialLinkWrapper,
} from './SocialBanner.styled'

export const SocialBanner = (props: SocialBannerType): Nullable<JSX.Element> => {
    const {
        socialBannerTitle,
        socialBannerDescription,
        facebookLink,
        linkedInLink,
        twitterLink,
        socialButtonUrl,
        socialButtonLabel,
        showSocialBanner,
    } = props

    if (!showSocialBanner) return null

    return (
        <SocialBannerWrapper>
            <SocialBannerTitle>{socialBannerTitle}</SocialBannerTitle>
            <SocialBannerDescription>{socialBannerDescription}</SocialBannerDescription>
            <SocialLinkWrapper>
                {facebookLink && (
                    <a href={facebookLink} target="_blank" rel="noreferrer">
                        <FacebookIcon colorCode="p500" />
                    </a>
                )}
                {linkedInLink && (
                    <a href={linkedInLink} target="_blank" rel="noreferrer">
                        <LinkedInIcon colorCode="p500" />
                    </a>
                )}
                {twitterLink && (
                    <a href={twitterLink} target="_blank" rel="noreferrer">
                        <TwitterIcon colorCode="p500" />
                    </a>
                )}
            </SocialLinkWrapper>
            <Link to={socialButtonUrl}>
                <Button>{socialButtonLabel}</Button>
            </Link>
        </SocialBannerWrapper>
    )
}
